import { MatDialog } from "@angular/material";
import { NgxSpinnerService } from "ngx-spinner";
import { ClaveUnicaService } from 'src/app/services/clave_unica.service';
import { GLOBAL } from 'src/app/services/global';
var ClaveUnicaButtonComponent = /** @class */ (function () {
    function ClaveUnicaButtonComponent(spinner, claveUnicaService, dialog) {
        this.spinner = spinner;
        this.claveUnicaService = claveUnicaService;
        this.dialog = dialog;
    }
    ClaveUnicaButtonComponent.prototype.claveunica = function () {
        var _this = this;
        this.spinner.show();
        this.dialog.closeAll();
        this.claveUnicaService.getToken().subscribe(function (response) {
            var externalUrl = response.url;
            console.log("External url: ", externalUrl);
            var urlObj = new URL(externalUrl);
            var state = urlObj.searchParams.get('state');
            sessionStorage.setItem('authState', state);
            var route = sessionStorage.getItem('selected-route');
            var datos = { state: state, env: GLOBAL.env, route: route };
            _this.claveUnicaService.guardarDatos(datos).subscribe(function (response) {
                console.log('Token generado:', response.token);
                _this.spinner.hide();
                window.open(externalUrl, '_self'); //, '_blank'
            }, function (error) {
                console.error('Error al guardar datos de la sesion:', error);
            });
        });
    };
    return ClaveUnicaButtonComponent;
}());
export { ClaveUnicaButtonComponent };
